<template>
  <div class="container-fluid">
      <div class="row">
        <div class="col-12">
          <!-- <h2 class="mb-4 text-center">{{__('lang.message.addtocart_success')}}</h2>{{parent_product}}{{parentID}}

          <span v-if="parentID == 'productdetail' || parentID == 'productlist'"> -->
            <FORM  action="https://felderer.de/elbridge/accept/?supplier=Helios" method="post" name="start" enctype="multipart/form-data" target="_parent" class="w-100">
                <div class="col-12 col-md-12">
                    <INPUT type="hidden" id="version" name="version"  value=""/>
                    <INPUT type="hidden" id="result" name="result" value="" />



                      <h4>{{__('lang.addtocart.head')}}</h4>
                      <b-table class="table table-basket table-responsive-md" responsive="md" details-td-class="p-0" :items="fans" :fields="table_fields" sort-icon-left detailsShowing="true" >
                        <template #cell(image)="row">
                          <router-link :to="{ name: 'productdetail', query: query_params(row.item.ref_no, row.item.version,1)}" role="button" target="_blank">
                                   <span @click.prevent="opendetail(row.item.ref_no, row.item.version,1,row.execution)" role="link"><b-img class="img-fluid" :src="row.item.image" fluid></b-img></span>
                          </router-link>
                        </template>

                       <!--  <template #cell(type)="{item}">
                              <router-link :to="{ name: 'productdetail', query: query_params(item.ref_no, item.version,1,item.execution)}" role="button" target="_blank" class="text-primary">
                                <span @click.prevent="opendetail(item.ref_no, item.version,1, item.execution)" role="link">{{item.type}}</span>
                              </router-link><br>
                        </template>
                        <template #cell(description_short)="{item}">
                              {{item.description_short}}<br>
                        </template>-->


                                   <template #cell(type)="typerow">

                                    <div :id="'hoverBtnId_' + typerow.item.ref_no">
                                      <b-button  variant="link" v-b-tooltip.hover class="text-left p-0">
                                        <span>
                                          <router-link :to="{ name: 'productdetail', query: query_params(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution) }"
                                            class="text-primary" role="button" target="_blank">
                                            <span @click.prevent="opendetail(typerow.item.ref_no, typerow.item.version, 1, typerow.item.execution)" role="link">{{ typerow.item.type }}</span>
                                          </router-link>
                                        </span>
                                      </b-button><br>
                                       {{ typerow.item.description_short }}
                                      <!-- <b-button  variant="link" v-b-tooltip.hover class="text-left">test </b-button> -->
                                    </div>
                                    <b-popover :target="'hoverBtnId_' + typerow.item.ref_no" triggers="hover" placement="auto"  custom-class="quickview">

                                        <template v-slot:default>
                                          <div class="media"><div><img class="img-fluid" :src="mediaserver_url + typerow.item.image" /></div>
                                              <div><h6>{{ typerow.item.type }}</h6>
                                              <p>{{ getLongDesc(typerow.item.product_descriptions ? typerow.item.product_descriptions[0].description_long : typerow.item.description_long) }}</p>

                                              </div>
                                          </div>
                                        </template>

                                    </b-popover>

                                  </template>








                        <template #cell(quantity)="qty_row">
                          <b-form-input class="form-control slim mt-n1" type="number" min="0" :id="'fans_'+ qty_row.index"  step="1" v-model="fans_new[qty_row.index].quantity"></b-form-input>
                        </template>
                        <!--
                        <template #cell(info)="row">
                          <button role="button" @click="row.toggleDetails" :class="row.detailsShowing ?  'btn m-0 p-0 text-primary' : 'btn m-0 p-0 text-primary collapsed'" data-toggle="collapse">
                            <svg class="icon">
                              <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                            </svg>
                          </button>
                        </template>
                        <template #row-details="row">
                          <div class="bg-white">
                            <div class="border-bottom">
                              <div class="container-fluid py-3">
                                <div class="row justify-content-center">
                                  <div class="col-2"><img class="img-fluid" :src="media_dir + row.item.image"/></div>
                                  <div class="col-7">
                                    <p class="mb-0">{{row.item.type}}</p>
                                    <h5 class="mb-3">{{row.item.description_short}}</h5>
                                    <p>{{row.item.description_long}}</p>
                                    <ul class="list-unstyled downloads">
                                      <li class="mb-1"><router-link :to="{ name: 'productdetail', query: query_params(row.item.ref_no)}" class="text-primary font-weight-bold" role="button" target="_blank">
                                          <svg class="icon">
                                            <use xlink:href="/assets/img/icon-sprite.svg#global.external-link" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                          </svg>{{__('lang.global.product.downloads.toproductdetailpage')}}</router-link>
                                      </li>
                                      <li :class="(row.item.datasheet=='undefined' || !row.item.datasheet) ? 'd-none':'mb-1' "><a class="text-primary font-weight-bold" :href="row.item.datasheet" target="_blank" role="button">
                                          <svg class="icon">
                                            <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                          </svg>{{__('lang.global.product.downloads.datasheet')}}<span class="d-block small font-weight-light text-secondary pl-4">{{row.item.datasheet}}</span></a></li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </template>
                        -->
                      </b-table>
                      <!-- </span> -->
                      <span v-if="accessories.length>0">
                        <h6>{{__('lang.addtocart.selectaccessories')}}:</h6>
                        <b-table class="table table-basket table-responsive-md" responsive="md" details-td-class="p-0" :items="accessories" :fields="table_fields" sort-icon-left detailsShowing="true" >
                          <template #cell(image)="row">
                            <router-link :to="{ name: 'productdetail', query: query_params(row.item.ref_no, row.item.product_child_version,0,0)}" role="button" target="_blank">
                                  <span @click.prevent="opendetail(row.item.ref_no, row.item.product_child_version,0,0)" role="link"><b-img class="img-fluid" :src="mediaserver_url+row.item.image" fluid></b-img></span>
                            </router-link>
                            <p>
                             <button role="button" type="button" @click.prevent="row.toggleDetails" :class="row.item.items && row.item.items.length>0  ? (row.detailsShowing ? 'btn btn-link btn-sm p-0': 'btn btn-link btn-sm p-0 collapsed'): 'd-none' " data-toggle="collapse">
                              <svg class="icon icon-xxs">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                              </svg>
                              {{__('lang.global.product.tabs.accessories')}} {{__('lang.global.to')}} {{row.item.ref_no}}
                             </button>
                            </p>
                          </template>
                         <!--  <template #cell(type)="{item}">
                                <router-link :to="{ name: 'productdetail', query: query_params(item.ref_no, item.product_child_version,0,0)}" role="button" target="_blank" class="text-primary">
                                  <span @click.prevent="opendetail(item.ref_no, item.product_child_version,0,0)" role="link">{{item.type}}</span>
                                </router-link><br>
                          </template>
                          <template #cell(description_short)="{item}">
                                {{item.description_short}}<br>
                          </template> -->
                           <template #cell(type)="typerow">

                                  <div :id="'hoverBtnId_' + typerow.item.ref_no">
                                    <b-button  variant="link" v-b-tooltip.hover class="text-left p-0">
                                      <span>
                                        <router-link :to="{ name: 'productdetail', query: query_params(typerow.item.ref_no, typerow.item.product_child_version, 0, 0) }"
                                          class="text-primary" role="button" target="_blank">
                                          <span @click.prevent="opendetail(typerow.item.ref_no, typerow.item.product_child_version, 0, 0)" role="link">{{ typerow.item.type }}</span>
                                        </router-link>
                                      </span>
                                    </b-button><br>
                                    <!-- <b-button  variant="link" v-b-tooltip.hover class="text-left">test </b-button> -->
                                     {{ typerow.item.description_short }}
                                  </div>
                                  <b-popover :target="'hoverBtnId_' + typerow.item.ref_no" triggers="hover" placement="auto"  custom-class="quickview">

                                      <template v-slot:default>


                                          <div class="media">
                                            <div><img class="img-fluid" :src="mediaserver_url + typerow.item.image" /></div>
                                            <div><h6>{{ typerow.item.type }}</h6>
                                                <p> {{ getLongDesc(typerow.item.description_long) }}</p>
                                            </div>
                                        </div>
                                      </template>

                                  </b-popover>

                                </template>
                          <template #cell(quantity)="qty_row">
                            <b-form-input class="form-control slim mt-n1" type="number" min="0" :id="'accessories_'+ qty_row.index"  step="1" v-model="accessories_new[qty_row.index].quantity"></b-form-input>
                          </template>
                         <!--  <template #cell(info)="row">
                            <button role="button" @click="row.toggleDetails" :class="row.detailsShowing ?  'btn m-0 p-0 text-primary' : 'btn m-0 p-0 text-primary collapsed'" data-toggle="collapse">
                              <svg class="icon">
                                <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                              </svg>
                            </button>
                          </template> -->
                          <template v-slot:row-details="row">
                           <!--  <div class="bg-white">
                              <div class="border-bottom">
                                <div class="container-fluid py-3">
                                  <div class="row justify-content-center">
                                    <div class="col-2"><img class="img-fluid" :src="media_dir + row.item.image"/></div>
                                    <div class="col-7">
                                      <p class="mb-0">{{row.item.type}}</p>
                                      <h5 class="mb-3">{{row.item.desc_short}}</h5>
                                      <p>{{row.item.desc_long}}</p>
                                      <ul class="list-unstyled downloads">
                                        <li class="mb-1"><router-link :to="{ name: 'productdetail', query: query_params(row.item.ref_no)}" class="text-primary font-weight-bold" role="button" target="_blank">
                                            <svg class="icon">
                                              <use xlink:href="/assets/img/icon-sprite.svg#global.external-link" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                            </svg>{{__('lang.global.product.downloads.toproductdetailpage')}}</router-link>
                                        </li>
                                        <li :class="(row.item.datasheet=='undefined' || !row.item.datasheet) ? 'd-none':'mb-1' "><a class="text-primary font-weight-bold" :href="row.item.datasheet" target="_blank" role="button">
                                            <svg class="icon">
                                              <use xlink:href="/assets/img/icon-sprite.svg#global.file.pdf" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                            </svg>{{__('lang.global.product.downloads.datasheet')}}<span class="d-block small font-weight-light text-secondary pl-4">{{row.item.datasheet}}</span></a></li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div> -->
                            <div class="bg-white pl-8">
                              <!-- <button v-b-toggle="'collapse-' + row.item.ref_no" :class="!row.item.items ?'d-none' :'btn btn-link btn-sm p-0'" @click="$event.target.classList.toggle('collapsed')" data-toggle="collapse">
                                <svg class="icon icon-xxs">
                                  <use xlink:href="/assets/img/icon-sprite.svg#global.collapse" xmlns:xlink="http://www.w3.org/1999/xlink"></use>
                                </svg>
                                {{__('lang.global.product.tabs.accessories.items')}} {{__('lang.global.to')}} {{row.item.ref_no}}
                              </button>
                              <b-collapse :id="'collapse-'+ row.item.ref_no" class="mt-2 border-bottom"> -->
                                <b-table class="table table-striped table-borderless table-responsive-md nesteditemsrow" thead-tr-class="d-none" details-td-class="p-0" striped borderless responsive="md" :items="row.item.items" :fields="table_fields" sort-icon-left>
                                  <template #cell(image)="{item}">
                                    <b-img class="img-fluid" height="100" width="100" :src="mediaserver_url+item.image" fluid ></b-img>
                                  </template>
                                  <template #cell(quantity)="qty_row_det">
                                      <b-form-input class="form-control slim mt-n1" type="number" min="0" :id="'accessories_'+ row.index +'_'+ qty_row_det.index"  step="1" v-model="accessories_new[row.index].items[qty_row_det.index].quantity"></b-form-input>
                                  </template>
                <!--                   <template #cell(type)="{item}">
                                        <router-link :to="{ name: 'productdetail', query: query_params(item.ref_no, item.product_child_version,0,0)}" role="button" target="_blank" class="text-primary">
                                          <span @click.prevent="opendetail(item.ref_no, item.version,0,0)" role="link">{{item.type}}</span>
                                        </router-link><br>
                                  </template> -->


                                    <template #cell(type)="typerow">

                                      <div :id="'hoverBtnId_' + typerow.item.ref_no">
                                        <b-button  variant="link" v-b-tooltip.hover class="text-left p-0">
                                          <span>
                                            <router-link :to="{ name: 'productdetail', query: query_params(typerow.item.ref_no, typerow.item.product_child_version, 0, 0) }"
                                              class="text-primary" role="button" target="_blank">
                                              <span @click.prevent="opendetail(typerow.item.ref_no, typerow.item.product_child_version, 0, 0)" role="link">{{ typerow.item.type }}</span>
                                            </router-link>
                                          </span>
                                        </b-button><br>
                                         {{ typerow.item.description_short }}
                                        <!-- <b-button  variant="link" v-b-tooltip.hover class="text-left">test </b-button> -->
                                      </div>
                                      <b-popover :target="'hoverBtnId_' + typerow.item.ref_no" triggers="hover" placement="auto"  custom-class="quickview">

                                          <template v-slot:default>
                                            <div class="media"><div><img class="img-fluid" :src="mediaserver_url + typerow.item.image" /></div>
                                                <div><h6>{{ typerow.item.type }}</h6>
                                                  <p>{{ getLongDesc(typerow.item.description_long) }}</p>
                                                </div>
                                            </div>
                                          </template>

                                      </b-popover>

                                    </template>


                                </b-table>
                             <!--  </b-collapse> -->
                            </div>
                          </template>
                        </b-table>
                      </span>
                </div>
            </FORM>
        </div>
      </div>

 </div>


</template>

<script>
      import productdataApi from './services/api/productdataAPI.js'
      import userApi from "./services/api/user";
      export default {
        props: ['parentID','parent_product'], //parentID from shoppingcart ='shoppingcart', from product ='productdetail', from resultlist='productlist'
        computed: {
            table_fields: {
              get () {
                /* not render if add dynamic
                var tablefields=this.setFieldLabels(this.$store.state.productdata.table_fields)
                tablefields.splice(5,0, {key: 'quantity', label: this.__('lang.addtocart.quantity')})
                tablefields.unshift({key: 'image', label: ''})

                return tablefields
                */
               return this.setFieldLabels(this.$store.state.productdata.table_fields_tocart)
              }
            },
           /*  media_dir : {
              get () {
                  return this.$store.state.productdata.media_dir
              }
            }, */
            user_settings:{
              get () {
                  return this.$store.state.operatingpoint.user_settings
              }
            },
            fans: function() {
              var fans = [];
             // Object.assign(this.parent_product, { quantity: 1 });

              var parentprod = this.parent_product
                //if (this.parentID == 'shoppingcart')  fans = []; // edit qty fans  in cart, fan not exists in modal
                if (this.parentID=='productdetail' && this.parent_product.flag_fan==1 ) fans.push(this.$store.state.productdata.product_data)
                else if(this.parentID == 'productlist' ){
                  fans.push(parentprod)
                }
                else if(this.parentID == 'shoppingcart'){
                  console.log('fans: this.parent_product:');
                  //Object.assign(this.parent_product, { quantity: 0 })
                  this.parent_product.quantity=0
                  console.log(this.parent_product);


                    fans.push(parentprod)
                }

              return fans
            },
            accessories_FUNKTIONIERT:{
              get(){
                var accessories = []

                if (this.parentID == 'productdetail')  accessories=this.$store.state.productdata.product_data.accessories
                else if (this.parentID == 'shoppingcart') {
                  if(this.parent_product.flag_fan==1){
                    //get accessoires to fan
                     if(this.parent_product.hasOwnProperty('accessories') && this.parent_product.accessories.length>0) accessories=this.parent_product.accessories
                  }
                  else { //if(this.parent_product.flag_fan==2){
                    //get accessoires to accessoires
                   /*  console.log('Acces this.parent_product:')
                    console.log(this.parent_product) */
                    if(this.parent_product.hasOwnProperty('items') && this.parent_product.items.length>0) accessories=this.parent_product.items

                  }
                }
                else if (this.parentID == 'productlist'){
                  if(this.parent_product.accessories.length>0) accessories=this.parent_product.accessories
                }
                /* accessories.forEach(function (accessorie) {
                      Object.assign(accessorie, {quantity:0})
                }); */
                /*  //open all detailrows
                accessories.forEach(function (accessorie) {
                      Object.assign(accessorie, {_showDetails:true})
                });  */

                return accessories
              },
              set(value){
                  //this.$store.commit('shoppingcart/updateAccessories', value)
              }
            },
            accessories:{
              get(){
                var accessories = []

                accessories=this.$store.state.productdata.accessories
               /* --
                if (this.parentID == 'productdetail')  accessories=this.$store.state.productdata.accessories
                else if (this.parentID == 'shoppingcart') {
                  if(this.parent_product.flag_fan==1){
                    //get accessoires to fan
                     if(this.parent_product.hasOwnProperty('accessories') && this.parent_product.accessories.length>0) accessories=this.parent_product.accessories
                  }
                  else { //if(this.parent_product.flag_fan==2){
                    //get accessoires to accessoires
                    console.log('Acces this.parent_product:')
                    console.log(this.parent_product)
                    if(this.parent_product.hasOwnProperty('items') && this.parent_product.items.length>0) accessories=this.parent_product.items

                  }
                }
                else if (this.parentID == 'productlist'){
                  if(this.parent_product.accessories.length>0) accessories=this.parent_product.accessories
                }
                --*/


                /* accessories.forEach(function (accessorie) {
                      Object.assign(accessorie, {quantity:0})
                }); */
                /*  //open all detailrows
                accessories.forEach(function (accessorie) {
                      Object.assign(accessorie, {_showDetails:true})
                });  */

                return accessories
              },
              set(value){
                  //this.$store.commit('shoppingcart/updateAccessories', value)
                  this.$store.commit('productdata/setAccessories', value)

              }
            },
            fans_new:function(){
              var fans=this.fans

              var call_from= this.parentID
              fans.forEach(function (fan) {

                 if(call_from=='shoppingcart') fan.quantity=0

                 //--fan.quantity=1  // 2023-08-03 auskommentiert wegen shoppingcart 'tote Zeile' keine reaktion auf änderung by anzahl,rabatt wenn artikel über modalen dialog hizugefügt wurde
                });
                return fans

            },
            accessories_new:function(){
              var accessories=this.accessories
              accessories.forEach(function (accessorie) {
               /*  console.log('accessorie.quantity:')
                console.log(accessorie.quantity)
                 if(accessorie.quantity=='undefined' || accessorie.quantity=='') accessorie.quantity=0
                 if(accessorie.items && accessorie.items.length>0) {

                    accessorie.items.forEach(function (item) {
                      console.log('item.quantity:')
                      console.log(item.quantity)
                      if(item.quantity == 'undefined' || item.quantity=='') item.quantity=0
                    })
                 }  */
              });
              return accessories
            },


            session: {
              get () {
                return this.$store.state.user.session
              },
              set (value) {
                    this.$store.commit('user/updateSession', value)
                }
            },
            user: {
              get () {
                return this.$store.state.user.user
              },
              set (value) {
                    this.$store.commit('user/updateUser', value)
                }
            },
          selectedlocale: {
            get() {
              return this.$store.state.user.selectedlocale
            },
            set(value) {
              this.$store.commit('user/updateSelectedlocale', value)
            }
          }


        },
        data() {
          return {
            //fan_ref_no:'',
            mediaserver_url:'',//'https://globalstest.heliosventilatoren.de' ,


          }
		    },
        methods: {
          opendetail(refno,version, flag_fan) {
            var query_params=this.query_params(refno,version, flag_fan)

            if(this.user.auth){
              axios.post('/user/access/token', {navigation: 1}).then(response => {
                        Object.assign(query_params,  {access_token:response.data.access_token});
                    }).catch(function (error) {
                    });
            }
            let routeData = this.$router.resolve({name: 'productdetail', query: query_params });
            window.open(routeData.href, '_blank');
          },
          query_params(refno,version, flag_fan){
              var query_params={
                  ref_no: refno,
                  version: version,
                  language_id: this.$lang().locale  //navigator.language,
              }
              return query_params
          },
          setFieldLabels: function(value){
            var array =[];
            var sortable=false
            for(var i = 0; i < value.length; i++){

              if(value[i].key=='price') {
                array.push({key: value[i].key, label: this.__(value[i].label), sortable: sortable, sortByFormatted: sortable, _showDetails:true,  thClass: 'small border-top-0',
                  formatter: (value, key, item) => {
                    var price= parseFloat(value);
                    if (!this.user.auth) return this.__('lang.message.loginrequired');
                    else if (this.user.countries_price == '') return this.__('lang.global.onrequest'); //+ ' PreisLand unbekannt';
                   // else if (this.user.auth && (this.user.countries_price != this.selectedlocale.country || this.user.countries_price != this.user.countries_iso)) return this.__('lang.global.onrequest');// + ' fremdes Land';
                    else if (this.user.auth && this.user.countries_price != this.selectedlocale.country) return this.__('lang.global.onrequest');// + ' fremdes Land';
                    return price >0 ? price.toFixed(2): this.__('lang.global.onrequest');
                  }
                })
              }
              else if(value[i].key=='image'){
                 array.push({key: value[i].key, label: this.__(value[i].label), sortable: sortable, sortByFormatted: sortable, _showDetails:true,   thClass: 'small border-top-0 col-md-1', tdClass: 'img-td'})
              }
              else {
                  if(value[i].key== 'info' || value[i].key== 'cloud' || value[i].key == 'quantity') sortable=false
                  array.push({key: value[i].key, label: this.__(value[i].label), sortable: sortable, sortByFormatted: sortable, _showDetails:true, thClass: 'small border-top-0',
                    formatter: (value, key, item) => {
                      if(typeof value == "number") return Math.round(value);
                      else return value;
                    }
                  })
              }
              //console.log(value[i]);
            }

            return array;
          },
          storeSelectedProducts: function(){
              var parent_ref_no=this.parent_product.ref_no
              var accessoriess_extend_parent=[]
              var selectedFans=[]
              var selectedAccessories=[]
              var user_settings=this.user_settings
              var parentID = this.parentID

              var stored_products=this.$store.state.shoppingcart.shoppingcartlist
              var index = stored_products.length - 1 //this.parent_product.index?parseInt(this.parent_product.index):stored_products.length-1

              var countaccessories = this.accessories.length

              index++

              selectedFans = this.fans.filter(obj => {
                return obj.quantity > 0
              })
              if(selectedFans.length>0){
               // add discount for each product:
                selectedFans.forEach(function (fan) {
                  Object.assign(fan, { positiontext: '', product_source: 1, countaccessories: countaccessories, productmarker:0, incrementedColumn:0 },user_settings)
                });

                stored_products.splice(index,0,...selectedFans)
                index++
              }

              var selectedSubAccessories=[]
              selectedAccessories = this.accessories.filter(obj => {
                if (obj.items && obj.items.length > 0) {
                  Object.assign(obj, {countaccessories: obj.items.length})
                  var sub_accessories = obj.items.filter(sub_a => {
                                 return  sub_a.quantity > 0
                  })
                  if(sub_accessories.length>0) selectedSubAccessories.push(...sub_accessories) //=[...selectedSubAccessories, ...sub_accessories]
                }
                return obj.quantity > 0
              })
              selectedAccessories.push(...selectedSubAccessories)
              selectedAccessories.forEach(function (el) {
                var o = Object.assign({}, el, { parent_product: parent_ref_no, product_source: 1, productmarker: 0 })
                accessoriess_extend_parent.push(o)
              })
              selectedAccessories= accessoriess_extend_parent
              // add discount for each product:
              selectedAccessories.forEach(function (accessorie) {
                Object.assign(accessorie, { positiontext: '', product_source: 1, productmarker: 0, incrementedColumn:0 }, user_settings)
              });

            stored_products.splice(index, 0, ...selectedAccessories)
              /* 2022-11-17 each product must add to shoppingcart separate!
              // sum products with same ref_no and parent:
               let stored_products_qtysum = stored_products.reduce(function(acc, curr) {
                //let findIndex = acc.findIndex(item => (item.ref_no == curr.ref_no && item.parent_product == curr.parent_product));
                let findIndex = acc.findIndex(item => item.ref_no == curr.ref_no);
                  if (findIndex === -1) {
                    acc.push(curr)
                  } else {
                    //acc[findIndex].quantity = (curr.parent_product && parentID=='shoppingcart') || parentID!='shoppingcart' ? parseInt(acc[findIndex].quantity) +  parseInt(curr.quantity) : parseInt(curr.quantity)
                    acc[findIndex].quantity = parseInt(acc[findIndex].quantity) +  parseInt(curr.quantity)
                  }
                  return acc;
              }, [])

              //console.log('stored_products_qtysum:')
              stored_products=stored_products_qtysum
               */

              var show_price=true;
              if (!this.user.auth || this.user.countries_price == '' || (this.user.auth && this.user.countries_price != this.selectedlocale.country) ) {
                  show_price=false
              }

              let i=0
              stored_products.forEach(function(el){
                 if(!show_price) el.price=0
                 Object.assign(el, {index: i})
                 i++
              })

            /*   console.log('storeSelectedProducts stored_products:')
              console.log(stored_products) */

              this.$store.commit('shoppingcart/updateShoppingcartList', stored_products)

              // set  quantity = 0
              this.accessories.forEach(function(obj){
                obj.quantity=0
                if(obj.items && obj.items.length>0) {
                  obj.items.forEach(function(subobj){
                    subobj.quantity=0
                  })
                }
              })
              document.getElementById('closeModalAccessories').click();
          },
          // ToDo:
          async getProductAccessories(ref_no,version){
            var params = { ref_no: ref_no, version: version, language_id: this.$lang().locale , state :'A'}
            /* call from shoppingcart set fan quantity=0*/
            if(this.parentID=='shoppingcart'){
                this.fans.forEach(function(el){
                            Object.assign(el, {quantity: 0})

                })
            }

            this.accessories = []
            productdataApi.getProductAccessories(params)
              .then(response => {
                  this.accessories=response.data.productaccessories
              })
              .catch(function () {
                 console.log('getProductAccessories Error');
              });


          },
          getLongDesc(desc) {
            var str=''
            if(desc!=null)  str = desc.replace(/(<([^>]+)>)/ig, '');
            return str.length > 255 ? str.substring(0, 255) + '...' : str;
          },
          createFeldererJson() {
              var list = [];
              var cartitem = {};
              var selectedFans=[]
              var selectedAccessories=[]

              selectedFans = this.fans.filter(obj => {
                  return obj.quantity > 0
              })

              var selectedSubAccessories=[]
              selectedAccessories = this.accessories.filter(obj => {
                  if (obj.items && obj.items.length > 0) {
                      Object.assign(obj, {countaccessories: obj.items.length})
                      var sub_accessories = obj.items.filter(sub_a => {
                          return  sub_a.quantity > 0
                      })
                      if(sub_accessories.length>0) selectedSubAccessories.push(...sub_accessories) //=[...selectedSubAccessories, ...sub_accessories]
                  }
                  return obj.quantity > 0
              })
              selectedAccessories.push(...selectedSubAccessories)

              selectedFans.forEach(function (el) {
                  cartitem = {
                      MANUFACTURER_PID: el.ref_no,
                      MANUFACTURER_TYPE_DESC: el.type,
                      DESCRIPTION_SHORT: el.description_short,
                      QUANTITY: el.quantity,
                      ORDER_UNIT: "ST",
                      SUPPLIER_ID_GLN: "4010184000006",

                  }
                  list.push(cartitem);

              })
              selectedAccessories.forEach(function (el) {
                 /* var o = Object.assign({}, el, { parent_product: parent_ref_no, product_source: 1, productmarker: 0 })
                  accessoriess_extend_parent.push(o)*/

                  cartitem = {
                      MANUFACTURER_PID: el.ref_no,
                      MANUFACTURER_TYPE_DESC: el.type,
                      DESCRIPTION_SHORT: el.description_short,
                      QUANTITY: el.quantity,
                      ORDER_UNIT: "ST",
                      SUPPLIER_ID_GLN: "4010184000006",

                  }
                  list.push(cartitem);

              })


                var strJson = JSON.stringify (list);
                console.log(strJson)
                return (strJson);
          },
          async logoutAndSubmit() {
                try {
                    var session = this.session
                    this.$store.dispatch('shoppingcart/resetState')
                    this.$store.dispatch('operatingpoint/resetState')
                    this.$store.dispatch('user/resetState')
                    this.$store.dispatch('validation/resetState')
                    this.$store.dispatch('projectData/resetState')
                    this.$store.dispatch('alert/resetState')


                   /* this.$store.dispatch('globalData/resetState')
                    this.$store.dispatch('user/resetState')
                    this.$store.dispatch('validation/resetState')
                    this.$store.dispatch('projectData/resetState')
                    this.$store.dispatch('operatingpoint/resetState')
                    this.$store.dispatch('alert/resetState')
                    this.$store.commit('globalData/updateContentnav', 1)*/

                    //--await userApi.logout(this.session);
                    this.$store.commit('globalData/updateFeldererState', true)
                    document.start.submit();
                } catch (error) {
                    console.log("Logout failed:", error);
                }
          },
          sendToFelderer() {
                var strJson=this.createFeldererJson();
                var result =[];
                result.push(strJson);


                document.getElementById('version').value='1.0'
                document.getElementById('result').value=result;

                this.logoutAndSubmit.call({ session: this.session });

          },






        },
        mounted () {

        },
        created() {

        },
    }


</script>
